'use client';

import '../../index.css';
import NextApp from './app';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <NextApp>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '2rem',
          textAlign: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '350px',
        }}
      >
        <h1 style={{ fontSize: '3rem', marginBottom: '10px' }}>500</h1>
        <h2 style={{ marginBottom: '2px', marginTop: '0' }}>Oops! Something went wrong.</h2>
        <p>
          Uh-oh! It appears the watch hands are tangled. Our technical team is untangling the issue. Thank you for your
          patience as we restore seamless browsing
        </p>
      </div>
    </NextApp>
  );
}
